export enum ColumnDefinitionProperties {
  Field = 'field',
  Sort = 'sort',
  Width = 'width',
  Hide = 'hide',
  Pinned = 'pinned',
}
